var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-container editor-container"},[_c('textarea',{staticClass:"tinymce-textarea",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }